import { render } from "./EditPatient.vue?vue&type=template&id=429c8128&scoped=true"
import script from "./EditPatient.vue?vue&type=script&lang=js"
export * from "./EditPatient.vue?vue&type=script&lang=js"

import "./EditPatient.vue?vue&type=style&index=0&id=429c8128&scoped=true&lang=scss"
import "./EditPatient.vue?vue&type=style&index=1&id=429c8128&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429c8128"]])

export default __exports__